

<template>
  <div style="background-color: rgba(236, 243, 255, 1); position: relative;">
    <HeadVue></HeadVue>
    <section class="banner" style="margin-top: 60px">
      <div class="banner-cotent">
        <div style="margin-right: 535px">
          <h1 class="title">明晟大模型，为工业企业应用而生</h1>
        </div>
<!--        <div class="wave" style="margin-right: 10%">-->
<!--          <img referrerpolicy="no-referrer" :src="require('./assets/img/banner2.png')"  class="banner-img">-->
<!--        </div>-->
      </div>

    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 55px;margin-bottom: 30px">
        <h2 class="section-title">10年累计+全栈技术能力</h2>
      </div>
      <div class="card-container">
        <div class="card">
          <div class="card-icon">
            <img src="./assets/img/card1.png" alt="训练" class="card-icon">
            <h3>数据</h3>
          </div>
          <p>•海量优质数据源判断和储备</p>
          <p>•万亿级多语语料抽取、结构化、质量评估全流程经验</p>
          <p>•千亿级多粒度的大规模聚类系统</p>
        </div>
        <div class="card">
          <div class="card-icon">
            <img src="./assets/img/card2.png" alt="训练" class="card-icon">
            <h3>算法</h3>
          </div>
          <p>•明晟自研s-can神经网络算法，更接近人类生物大脑的神经元网络架构</p>
          <p style="text-align: justify">•降低消耗与资源占用：自动对网络中不重要的神经元连接进行裁剪，从而降低无谓的运算消耗以及系统资源占用</p>
        </div>
        <div class="card">
          <div class="card-icon">
            <img src="./assets/img/card3.png" alt="训练" class="card-icon">
            <h3>算力</h3>
          </div>
          <p>•（拟筹建中）自建算力中心：降低长期成本，优化资源使用并增强数据处理能力。</p>
          <p>•有效整合各方资源，推动数字化转型，更加高效地利用算力，实现战略目标</p>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 55px;margin-bottom: 30px">
        <h2 class="section-title">性能领先的基座大模型</h2>
      </div>
      <div class="table-container">
        <div>
          <img src="./assets/img/table1.png">
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 25px;margin-bottom: 30px">
        <h2 class="section-title">专为工业企业设计</h2>
      </div>
      <div class="feature-section">
        <div class="feature-item">
          <div class="feature-text">
            <h3>更聪明灵活</h3>
            <p>明晟大模型21亿参数在垂直领域已达 同行70-130亿参数效果</p>
          </div>
          <div class="feature-img">
            <img src="./assets/img/feature1.png" alt="芯片架构">
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-text">
            <h3>多卡集群并行计算</h3>
            <p>支持多GPU卡并行计算，提供强大的分布式训练和推理能力，满足企业大规模AI应用需求</p>
          </div>
          <div class="feature-img">
            <img src="./assets/img/feature2.png" alt="多卡集群">
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-text">
            <h3>大模型套件全家桶</h3>
            <p>专业场景能力</p>
            <p style="margin-top: 10px">定制化AI大模型服务解决方案</p>
          </div>
          <div class="feature-img">
            <img src="./assets/img/feature3.png" alt="AI能力">
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">全链条大模型应用与咨询服务</h2>
      </div>
      <div class="service-icons">
        <div class="service-icon">
          <img src="./assets/img/service1.png" alt="Agent代理">
          <p>Agent开发全套</p>
          <p>智能任务执行</p>
        </div>
        <div class="service-icon">
          <img src="./assets/img/service2.png" alt="数据分析">
          <p>大模型中间件</p>
          <p>咨询和定制</p>
        </div>
        <div class="service-icon">
          <img src="./assets/img/service3.png" alt="知识库">
          <p>高级Prompt</p>
          <p>Engineering能力</p>
        </div>
        <div class="service-icon">
          <img src="./assets/img/service4.png" alt="云端">
          <p>大模型</p>
          <p>二次预训练</p>
        </div>
        <div class="service-icon">
          <img src="./assets/img/service5.png" alt="安全">
          <p>微调模型</p>
          <p>咨询与定制</p>
        </div>
      </div>
    </section>

    <FooterVue style="margin-top: 0"></FooterVue>
  </div>

</template>

<script>
import HeadVue from "@/views/common/HeadVue.vue";
import FooterVue from "@/views/common/FooterVue.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {FooterVue, HeadVue},
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
}
</script>

<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f5f9ff;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 40px;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.banner-cotent {
  height: 500px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image:  url("./assets/img/banner.png");
}

.banner {

}

.title{
  background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
  //width: 205px;
  height: 56px;
  overflow-wrap: break-word;
  font-size: 50px;
  font-family: Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 56px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
}
.title-desc {
  font-size: 22px;
  color: #333333;
}


.banner-img {
  max-width: 400px;
  margin: 0 auto;
}

.section {
  padding: 20px 0;
  text-align: center;
}

.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}
.card-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  //margin: auto;
  //max-width: 1200px;
}

.card {
  width: 406px;
  height: 300px;
  background: linear-gradient( 180deg, #CCE0FF 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #FFFFFF;
}

.card-icon {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
}

.card h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-left: 10px;
  margin-top: 5px;
}

.card p {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  text-align: justify;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.table-container {
  width: 1320px;
  margin: 30px auto;
  max-width: 1320px;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

th {
  background-color: #0066cc;
  color: white;
  padding: 12px;
  text-align: center;
}

td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

.highlight {
  background-color: #e6f7ff;
}

.green {
  color: green;
}

.red {
  color: red;
}

.feature-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.feature-item:nth-child(even) {
  flex-direction: row-reverse;
}


.feature-text {
}

.feature-text h3 {
  font-weight: 700;
  font-size: 22px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
  text-align: left;
}

.feature-text p {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  text-align: left;
  width: 339px;
  margin-top: 30px;
}

.service-icons {
  display: flex;
  justify-content: space-around;
  max-width: 1000px;
  margin: 50px auto;
  flex-wrap: wrap;
  padding-bottom: 90px;
}

.service-icon {
  font-weight: 700;
  font-size: 20px;
  color: #333333;
}

.service-icon img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.service-icon p {
  font-family: "Alimama ShuHeiTi-Bold";
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: #333333;
  //line-height: 20px !important;
}

.footer {
  background-color: #0066cc;
  color: white;
  padding: 40px 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin: 10px;
}

.footer-column h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-column p, .footer-column a {
  color: #e6f0ff;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
</style>
